import { Directive, ElementRef, EventEmitter, HostListener, inject, Output } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[lxDetectOutsideClick]',
})
export class ClickOutsideDirective {
  @Output() clickOutside = new EventEmitter<void>();

  private readonly el = inject(ElementRef);

  @HostListener('document:mousedown', ['$event.target'])
  @HostListener('document:focusin', ['$event.target'])
  handleOutsideInteraction(target: HTMLElement) {
    if (!this.el.nativeElement.contains(target)) {
      this.clickOutside.emit();
    }
  }
}
